import React from 'react';
import Container from '@/components/Container';
import Typography from '@mui/material/Typography';
import SwitchInput from '@/components/forms/SwitchInput';
import TextInput from '@/components/forms/TextInput';
import SelectInput from '@/components/forms/SelectInput';
import { DMObjectType } from '@/declarations/models/DMObjectType';
import { DMFilterSearchBlockModel } from '@/declarations/models/blocks/DMBlock';

interface ObjectTypesProps {
  blockPath: string;
  currentBlock: DMFilterSearchBlockModel;
  tComponents: (key: string) => string;
  tCommon: (key: string) => string;
  filterEnabled: boolean;
}

const FilterObjectTypes: React.FC<ObjectTypesProps> = ({
  blockPath,
  currentBlock,
  tComponents,
  tCommon,
  filterEnabled,
}) => (
  <Container gap={0} fullWidth column right>
    <Container fullWidth>
      <Container fullWidth left>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          {tComponents('DMFilterSearch.ObjectTypesTitleLabel')}
        </Typography>
      </Container>
      <Container fullWidth right>
        <div style={{ width: '400px', display: 'flex', alignItems: 'end' }}>
          <SwitchInput
            path={`${blockPath}.useObjectTypesAsOuterRestriction`}
            label={tComponents('DMFilterSearch.ItemsRestriction')}
          />
          <div style={{ width: '180px' }}>
            <SwitchInput
              fullWidth={false}
              path={`${blockPath}.userCanFilterObjectTypes`}
              label={tComponents('DMFilterSearch.UserFiltrationOnWebsite')}
            />
          </div>
        </div>
      </Container>
    </Container>
    <Container fullWidth>
      <SelectInput
        options={Object.values(DMObjectType)}
        getOptionKey={(o) => o}
        getOptionLabel={(o) => tCommon(`DMContentType.${o}`)}
        path={`${blockPath}.objectTypes`}
        label={tComponents('DMFilterSearch.ObjectTypesSelectInputLabel')}
        size='small'
        multiSelect
        initialMultiSelectValue={currentBlock?.objectTypes}
      />
      {filterEnabled && (
        <div style={{ width: '30%' }}>
          <TextInput
            path={`${blockPath}.objectTypesDropDownMenuTitle`}
            label={tComponents('DMFilterSearch.ObjectTypesDropDownMenuTitleLabel')}
          />
        </div>
      )}
    </Container>
  </Container>
);

export default FilterObjectTypes;
